import { useRef } from 'react';
import type { HighwayMaintenanceFeePenaltyTicketSummary } from '#/components/ui/tickets/highway-maintenance-fee-penalty/model';

export type QueryResultOption = 'fee_required' | 'no_fee' | 'query_failed';

interface QueryResult {
  type: QueryResultOption;
}

export interface QueryResultFeeRequired extends QueryResult {
  type: 'fee_required';
  handlingFee: number;
  amount: number;
}
export interface QueryResultNoFee extends QueryResult {
  type: 'no_fee';
}
export interface QueryResultQueryFailed extends QueryResult {
  type: 'query_failed';
  reason: string;
}

export type FillQueryResultDialogResult =
  | QueryResultFeeRequired
  | QueryResultNoFee
  | QueryResultQueryFailed;

export interface FillQueryResultValue extends QueryResult {
  amount: string;
  handlingFee: string;
  reason: QueryResultQueryFailed['reason'];
}

export type FillQueryResultDialogRef = {
  open: (
    ticket: HighwayMaintenanceFeePenaltyTicketSummary,
  ) => Promise<[FillQueryResultDialogResult | undefined, () => void]>;
  queryResultValue: FillQueryResultValue;
};

export const useFillQueryResultDialog = () => {
  const modalRef = useRef<FillQueryResultDialogRef>(null);
  const open = (ticket: HighwayMaintenanceFeePenaltyTicketSummary) =>
    modalRef.current?.open(ticket);
  return { props: { modalRef }, open };
};
